import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { fmtDate } from "@/lib/ui";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogFooter,
} from "@/components/ui/dialog";
import { Plus, Car, Gauge, ChevronRight } from "lucide-react";

export default function Vehicules() {
  const navigate = useNavigate();
  const [vehicles, setVehicles] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ name: "", brand: "", model: "", plate: "", mileage: "", purchase_date: "", notes: "" });

  const load = () => api.get("/items?category=vehicle").then((r) => setVehicles(r.data));
  useEffect(() => { load(); }, []);

  const save = async () => {
    if (!form.name) return toast.error("Le nom est requis");
    await api.post("/items", { ...form, category: "vehicle", mileage: form.mileage ? parseInt(form.mileage) : null });
    toast.success("Véhicule ajouté");
    setOpen(false);
    setForm({ name: "", brand: "", model: "", plate: "", mileage: "", purchase_date: "", notes: "" });
    load();
  };
  const upd = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="font-display text-3xl font-semibold tracking-tight">Véhicules</h1>
          <p className="text-muted-foreground text-sm mt-1">Carnet de vie : révisions, pneus, contrôle technique. Échéances temporelles ET kilométriques.</p>
        </div>
        <Dialog open={open} onOpenChange={setOpen}>
          <DialogTrigger asChild>
            <Button data-testid="add-vehicle-btn" className="bg-primary hover:bg-primary/90 rounded-full"><Plus size={16} className="mr-1" /> Ajouter</Button>
          </DialogTrigger>
          <DialogContent className="omy-glass">
            <DialogHeader><DialogTitle>Ajouter un véhicule</DialogTitle></DialogHeader>
            <div className="grid grid-cols-2 gap-3">
              <div className="col-span-2"><Label>Nom *</Label><Input data-testid="vehicle-name-input" value={form.name} onChange={upd("name")} className="mt-1 bg-black/30" placeholder="Peugeot 3008" /></div>
              <div><Label>Marque</Label><Input value={form.brand} onChange={upd("brand")} className="mt-1 bg-black/30" /></div>
              <div><Label>Modèle</Label><Input value={form.model} onChange={upd("model")} className="mt-1 bg-black/30" /></div>
              <div><Label>Immatriculation</Label><Input value={form.plate} onChange={upd("plate")} className="mt-1 bg-black/30" /></div>
              <div><Label>Kilométrage</Label><Input type="number" value={form.mileage} onChange={upd("mileage")} className="mt-1 bg-black/30" /></div>
              <div className="col-span-2"><Label>Date d'achat</Label><Input type="date" value={form.purchase_date} onChange={upd("purchase_date")} className="mt-1 bg-black/30" /></div>
              <div className="col-span-2"><Label>Notes</Label><Input value={form.notes} onChange={upd("notes")} className="mt-1 bg-black/30" /></div>
            </div>
            <DialogFooter><Button data-testid="vehicle-save-btn" onClick={save} className="bg-primary hover:bg-primary/90 rounded-full">Enregistrer</Button></DialogFooter>
          </DialogContent>
        </Dialog>
      </div>

      {vehicles.length === 0 && <p className="text-muted-foreground text-sm">Aucun véhicule. Ajoute-en un ou dis à OMY « j'ai changé mes pneus à 62 400 km ».</p>}
      <div className="grid sm:grid-cols-2 gap-4">
        {vehicles.map((v, i) => (
          <button key={v.id} data-testid={`vehicle-card-${i}`} onClick={() => navigate(`/app/memoire/${v.id}`)}
            className="omy-glass rounded-2xl p-6 text-left hover:border-primary/40 hover:-translate-y-1 transition-all group">
            <div className="flex items-center justify-between">
              <div className="w-11 h-11 rounded-xl bg-primary/15 flex items-center justify-center"><Car size={20} className="text-primary" /></div>
              <ChevronRight size={16} className="text-muted-foreground group-hover:translate-x-1 transition-transform" />
            </div>
            <h3 className="font-display font-medium mt-3">{v.name}</h3>
            <p className="text-xs text-muted-foreground">{v.plate} {v.purchase_date && `· ${fmtDate(v.purchase_date)}`}</p>
            {v.mileage != null && (
              <div className="flex items-center gap-2 mt-3 text-sm"><Gauge size={15} className="text-accent" /> {v.mileage.toLocaleString("fr-FR")} km</div>
            )}
          </button>
        ))}
      </div>
    </div>
  );
}
